import { createQueryKeys } from '@lukemorales/query-key-factory';
import { EQueryKeys } from 'common/enums/query-keys.enums.ts';
import {
  IOrderFlowDataReq,
  IOrderFlowDataRes,
  IOrderRampQueryParams,
  IOrderRampRes,
  IRatesReq,
  IRatesRes,
} from 'domains/on-off-ramp/interfaces/on-off-ramp.interfaces.ts';
import {
  getOrderFlowDataService,
  getOrderRampService,
  getRatesService,
} from 'domains/on-off-ramp/services/on-off-ramp.service.ts';

export const onOffRampQueryKeys = createQueryKeys(EQueryKeys.OnOffRamp, {
  getOrderFlowData: (reqData: IOrderFlowDataReq) => ({
    queryKey: ['get-order-flow-data'],
    queryFn: (): Promise<IOrderFlowDataRes> => getOrderFlowDataService(reqData),
  }),
  getRatesData: (params: IRatesReq) => ({
    queryKey: ['get-rates-data'],
    queryFn: (): Promise<IRatesRes> => getRatesService(params),
  }),
  getOrderRampData: (params: IOrderRampQueryParams) => ({
    queryKey: ['get-order-ramp-data'],
    queryFn: (): Promise<IOrderRampRes> => getOrderRampService(params),
  }),
});
